import {
  FC,
  useMemo,
  useCallback,
  useState,
  useEffect,
  ReactElement,
} from "react";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  LayoutConst,
  modalControllerActions,
  modalControllerSelector,
  ModalControllerSlice,
  SHARED_MODALS,
  useModal,
} from "core";
import {
  AppTester,
  getContextFromAppName,
} from "supporting";
import { ApplicationShared } from "core";
import { ApplicationTheme } from "shared/themes";
import { useAuth } from "core/hooks/auth/useAuth";
import { NavBar } from "shared/components/__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import WidgetLogin from "./WidgetLogin";
import MobileBottomBar from "./MobileBottomBar";
import { useSelector, useDispatch } from "react-redux";
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "../components/buttons";
import {
  FlexBox,
  FInter,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled,
  Colors,
  useToasts
} from "@brg/ui";
import { AbsoluteWrapper } from "../components/navbar-elements/navbar-create";
import PreviewIconOpen from "../assets/32/PreviewIconOpen";
import PreviewIconClosed from "../assets/32/PreviewIconClosed";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "shared/components/link/styles";
import {
  ANCHOR_ONLINES_LINK,
  ApplyBtn,
} from "shared/components/Footer/OnlinesFooter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import useQueryState from "shared/hooks/useQueryState";
import { OpenDayButton } from "./DeziiignNavbar";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { TagsSelector } from "../reducers/Tags";
import { DropdownWrapper } from "./HSEDeziiignNavbar";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { ORGANIZATION_LIST } from "shared/hooks/useGetCurrentTeam";
import { GeoTagModalSelector } from "shared/reducers/geoTagsModal";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo, { PhoneText } from "../components/TeamInfo/TeamInfo";
import { CourseInfoListController } from "shared/components/CourseInfoListController/CourseInfoListController";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import { AgreeOrClose, IconStates } from "./components/AgreeOrClose";
import { MobileSaveBlock } from "./components/MobileSaveBlock";
import FeedButton from "../components/NotificationsController/FeedButton";
import { setIsOpen } from "shared/reducers/OpenModal";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { Input } from "@brg/input";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { HsePolicies } from "shared/constants/HsePolicies";
import useNavbarSettings from "shared/hooks/useNavbarSettings";
import CreatePresentationButton from "./components/CreatePresentationButton";

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 1;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
  ${FlexBox} {
    @media (max-width: 568px) {
      margin-right: 6px; /* важно, изменения для всего сайта */
    }
  }
`;

export const NavbarOuter = styled(FlexBox) <{
  shifted?: boolean;
  isAgeytomesh?: boolean;
  logoLength?: number;
}>`
  max-width: 300px;
  position: relative;
  left: ${(p) => (p?.shifted ? `-${p?.logoLength}px` : 0)};
  transition: all 500ms;
`;

export const LogoName = styled(FlexBox) <{ isGeo?: boolean; isDafes?: boolean }>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${({ isDafes }) => isDafes ? '17px' : '24px'};
  line-height: ${({ isDafes }) => isDafes ? '22px' : '40px'};
  color: ${(p) =>
    p?.isDafes ? "#151514" : p.theme.navigationBar.logoName};
  position: relative;
  top: -1px;

  ${(p) =>
    p?.isGeo
      ? css`
          font-size: 17px;
          line-height: 22px;
          top: 1px;
        `
      : null};
`;

const RightSection = styled.div<{ isDafes?: boolean }>`
  display: flex;
  align-items: center;
`;

const CreateButton = styled.div<{ hide?: boolean, isMedia?: boolean, isKiiids?: boolean }>`
  display: ${({ hide }) => (hide ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  background: ${({ theme, isKiiids }) => isKiiids ? '#94209E' : theme.navigationBar.btns.create.bg};
  border-radius: ${({ isMedia, isKiiids }) => isMedia || isKiiids ? '8px' : '3px'};
  font-family: Inter, sans-serif;
  font-style: normal;
  height: 36px;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.navigationBar.btns.create.color};
  margin-right: 16px;
  // min-width: 132px;
  min-width: auto;
  padding: 8px 24px;
  max-width: min-content;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    height: ${({ isKiiids }) => isKiiids ? 40 : 32}px;
  }

  // @media (max-width: ${LayoutConst.screen.sm}px) {
  //   height: 30px;
  //   margin-right: 6px;
  //   min-width: 84px;
  //   padding: 6px 15px;
  //   max-width: 84px;
  // }
`;

const ExitButton = styled(RectangularButtonHollow) <{ isTeamEdit?: boolean }>`
  margin-right: 14px;
  // width: 87px !important;
  // min-width: 87px !important;
  width: auto !important;
  min-width: auto !important;
  height: 36px !important;
  margin-left: 16px;
  margin-right: 0;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: ${({ isTeamEdit }) => (isTeamEdit ? "28px" : "26px")} !important;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

`;

const SaveButton = styled(NavbarButtonFilled)`
  width: auto;
  min-width: auto;
  max-width: none;
  line-height: 16px;
  height: 36px !important;
  padding: 4px 24px;
  min-height: 24px;
  margin-right: 6px;
  font-weight: 600 !important;
  letter-spacing: normal;
`;

const AgreeButtonWrapper = styled.button<{ disabled?: boolean, isPreview?: boolean }>`
    margin-bottom: 6px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;
    ${({ isPreview }) =>
    isPreview
      ? css`
            margin-right: 16px;
          `
      : null};

  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ disabled }) =>
    disabled ? Colors.galBlack47 : Colors.galBlack100};
      }
    }
  }
  &:focus {
    outline: none;
  }
`;

const ProjectSaveButton = styled(NavbarButtonFilled)`
  // width: 132px;
  width: auto;
  min-width: auto;
  height: 36px !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: 568px) {
    // width: 102px;
    // min-width: 102px;
    width: auto;
    min-width: auto;
    height: 28px !important;
    min-height: 28px;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  &:disabled {
    background-color: ${({ theme }) =>
    theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) =>
    theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const IconWrapper = styled(FlexBox)`
  & svg {
    stroke-width: 0.2px;
  }
`


const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt &&
    css`
      & > div > div > div {
        background-color: rgb(231, 231, 231); 
      }
      div#navbar {
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px), (max-width: ${LayoutConst.screen.sm}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const LangSwitcherWrapper = styled(FlexBox) <any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin: 0 8px 0 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0 8px 0 0;
  }
`

type PropsT = {
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  primaryButtonEnabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPreviewClick?: () => void;
  dropdown?: ReactElement;
  currentTheme?: any;
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  toggleMobileEditor?: (val: boolean) => void;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  canSaveLgText?: boolean;
};

const DeziignNavBarMobile: FC<PropsT> = ({
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonEnabled,
  previewButtonEnabled,
  primaryButtonVisible = true,
  secondaryButtonVisible = true,
  primaryButtonText,
  secondaryButtonText,
  onPreviewClick,
  mobileEditorOpen,
  toggleMobileEditor,
  canSaveInDrafts,
  previewButtonVisible,
  closeIconVisible = false,
  canSaveLgText,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const isBooksGallllery = AppTester.isBooksGallllery()
  const { emit, token } = useAuth();
  const location = useLocation();
  const toasts = useToasts();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const modal = useSelector(modalControllerSelector);
  const modalToggle = useModal();
  const modalIsOpen = useMemo(() => !!modal.name, [modal]);
  const { hide: hideModal } = useModal();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/books/preview/:id",
    "/book-preview/:id",
    "/team-preview/:id",
    "/team-longread-preview/:id",
  ]);
  const isProjectPreview = useRouteMatch<{ id: string }>(["/preview/:id"]);
  const isProjectOnlyEdit = useRouteMatch<{ id: string }>(["/edit/:id"]);
  const isTeamPreview = useRouteMatch<{ id: string }>("/team-preview/:id");
  const isTeamLgPreview = useRouteMatch<{ id: string }>(
    "/team-longread-preview/:id"
  );
  const isBookChapterPreview = !!useRouteMatch([
    "/books/preview/:id",
    "/book-preview",
  ]);
  const isProjectEdit = useRouteMatch<{ id: string }>([
    "/edit/:id",
    "/books/edit/:id",
  ]);
  const isBookEdit = useRouteMatch<{ id: string }>([
    "/books/book-edit/:id",
    "/book-edit/:id",
  ]);
  const isBooksEdit = useRouteMatch<{ id: string }>("/books/edit/:id");
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const isProfileEdit = useRouteMatch<{ id: string }>(LinkTo.designerEdit);
  const isProfilePage = useRouteMatch<{ id: string }>(LinkTo.designer);
  const isTeamEdit = !!useRouteMatch(LinkTo.teamEdit);

  const {
    shouldDisplayEditorInterface,
    shouldDisplayNotifications,
    shouldDisplayGameButton,
    shouldDisplayCreateButton,
    shouldDisplayProDropdown,
    shouldDisplayChannelButton,
    shouldDisplayFeedButton,
    createButtonTitle,
    onLangSwitch,
  } = useNavbarSettings();

  const isEditPage = (
    isProjectEdit ||
    isTeamEdit ||
    isBookEdit ||
    isCompetitionEdit
  ) && shouldDisplayEditorInterface;

  // const isEditPage = false;

  const isEditPageOrPreview = (isEditPage || isPreview) && shouldDisplayEditorInterface;

  const isBrnd = AppTester.isBrnd();
  const isMedia = AppTester.isMediiia();
  const isCGRave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isLPU = AppTester.isLPUDesign();
  const id = isPreview && isPreview?.params?.id;
  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is430bp = useBreakpoint(470);
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const [{ lang, mainBookId }, setQueryParams] = useQueryState();
  const { initialTab, context: contextName } = useContextsTabs();

  const mainLogo = useGetLogo({})

  const [setUserParam] = useOnlinesParam();
  const onlinesUserParam = sessionStorage.getItem("userParam");

  const [, setVisibleModalMenuCategoriesMobile] = useState<boolean>(false);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);

  const closePopup = useCallback(() => {
    dispatch(setIsOpen(false));
  }, [dispatch]);

  const onMobileProjectSaveClick = () => {
    if (!primaryButtonEnabled) {
      toasts.error(t('nav.create_button.fields_required'))
      return
    }

    const onProjectSaveClick = (val: boolean) => {
      if (!!val) {
        onPrimaryClick && onPrimaryClick();
        modalToggle.hide();
        return;
      }

      modalToggle.hide();
    }

    modalToggle.show('project-publish', {
      onClick: onProjectSaveClick
    })
  }

  const isMainBookPreview = useMemo(() => (mainBookId && isBookChapterPreview), [isBookChapterPreview, mainBookId])

  const shouldVisibleTeamPreview = useMemo(
    () => isTeamEdit && !!previewButtonVisible,
    [isTeamEdit, previewButtonVisible]
  );

  const mobileIconState = useMemo(
    () => mobileEditorOpen ? IconStates.button : IconStates.close, [mobileEditorOpen, closeIconVisible])

  const isGeo = AppTester.isGeograffee();
  const isHSEDesign = AppTester.isHSEDesign();
  const isOnlines = AppTester.isOnlines();
  const isSuperPuper = AppTester.isSuperPuper();
  const isContinuumSite = AppTester.isContinuumSite();
  const isKiiidsArt = AppTester.isKiiidsArt()

  const isDafes = AppTester.isGeoDafes();
  const isBooks = !!useRouteMatch([
    LinkTo.hseBooks,
    "/hsebooks",
  ]);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isHseColors = AppTester.isHseColors();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isReportModalActive =
    useSelector(modalControllerSelector).name === "report";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isNotSavedDataModal =
    useSelector(modalControllerSelector).name === "not-saved-data";
  const isCompetitionLongreadSendProjectActive = useSelector(modalControllerSelector).name === "send-project-longread"

  const menuVisible = useMemo(
    () => (isOpen && !isNotSavedDataModal)
    , [isOpen, isNotSavedDataModal])

  const isGeoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;

  const setTheme = isSuperPuper || isCGRave || isContinuumSite || isAdcrDafesNet
    ? ApplicationTheme.black
    : isDafes
      ? ApplicationTheme.white
      : isGeo
        ? ApplicationTheme.grey
        : isGameDeziiign
          ? ApplicationTheme.additionalGreyTheme
          : isGalllleryBooks
            ? ApplicationTheme.additionalWhite_1
            : ApplicationTheme.white;

  const profile = useProfile();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);

  const isCreateLocationPage = !!useRouteMatch(LinkTo.createLocation);

  const isProHse = AppTester.isProHSE();
  const isPro = AppTester.isProDeziiign()

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  const { teamName } = useParams<{ teamName: string }>();
  const team = useExternalOrganization(teamName);

  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;

  const isMobileSelectTags = useMemo(
    () =>
      modalName === "tags" &&
      (isProjectOnlyEdit ||
        isBookEdit ||
        isCreateLocationPage ||
        isTeamEdit ||
        isBooksEdit ||
        isCompetitionEdit) &&
      isMobile,
    [
      isBookEdit,
      isBooksEdit,
      isCompetitionEdit,
      isTeamEdit,
      isCreateLocationPage,
      modalName,
      isMobile,
    ]
  );

  const shouldDisplayContextOnNavbar = useMemo(
    () => isHSEDesign && !isProfilePage,
    [isHSEDesign, isProfilePage]
  );

  const shouldVisibleSaveBtn = useMemo(() => {
    if (is744) {
      return false;
    }

    return (isEditPage && isTablet && primaryButtonVisible) || isProfileEdit;
  }, [isEditPage, isTablet, isProfileEdit, is744, primaryButtonVisible]);

  const shouldVisibleCourseList = isMobile && isLMS && !isTagsModalActive;

  const PhoneButton = useMemo(() => (isHseColors && !isOpen && (
    <FlexBox offsetRight={isMobile ? 16 : 0}>
      <RectangularButtonFilled smallPadding onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
        <PhoneText style={{ color: Colors.geoWhite100 }}>
          +7 999 999 99-99
        </PhoneText>
      </RectangularButtonFilled>
    </FlexBox>
  )), [isHseColors, isMobile, toasts, t, isOpen])

  // очередной костыль, я не понимаю почему у меня выдает ошибки при каждом изменний условий
  const isNeedTeamButtons = useMemo(
    () => isTeamEdit && !isCompetitionLongreadSendProjectActive && (secondaryButtonVisible || primaryButtonVisible)
    , [isCompetitionLongreadSendProjectActive, isTeamEdit, primaryButtonVisible])

  const cardUrl = Endpoints.cardsMnePw;

  const createKidsCard = useCallback(async () => {
    if (!profile) {
      return
    }
    const catalogs = await API.request()
      .endpoint(cardUrl)
      .url('api/Collection/GetCatalogs')
      .get()
      .addQuery('service', 'kids')
      .addQuery('userId', profile?.accountId)
      .addQuery('isUserCatalog', 'true')
      .send()
      .then((r: any) => r.json())

    const collectionId = catalogs?.[0]?.cardCollectionId


    const cardData: any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
    }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))

    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
  }, [cardUrl, profile])


  const isShadowModal = useMemo(
    () => SHARED_MODALS[modal?.name]?.shadowClosableBackground,
    [modal?.name]
  );
  const isActiveModal = useMemo(
    () => Boolean(modalName) && !isShadowModal,
    [modalName, isShadowModal]
  );

  const isMobileEditorOpen = useMemo(
    () => (mobileEditorOpen && isMobile && !!toggleMobileEditor) || false,
    [mobileEditorOpen, isMobile, toggleMobileEditor]
  );

  const someModalIsOpen = isOpen || isTagsModalActive || isActiveModal || isMobileEditorOpen


  const teamsList = useMemo(() => {
    let res = [];
    for (let key in ORGANIZATION_LIST) {
      //@ts-ignore
      if (!["ageytomesh", "books"].includes(key) && !ORGANIZATION_LIST[key].disabled
      ) {
        res.push({
          //@ts-ignore
          title: ORGANIZATION_LIST[key]?.[language === "ru" ? "titleRu" : "title"],
          name: key,
          value: `/teams/${key}`,
          ctx: "",
          active: location.pathname?.includes(key),
          external: false,
          isTeam: true,
        });
      }
    }
    return res;
  }, [location, language]);

  const urlsList = useMemo(
    () => [
      {
        title: t("nav.laboratory").toLowerCase(),
        name: "laboratory",
        value: "/teams/hselab",
        ctx: "",
        active:
          location.pathname.includes("/hselab") &&
          !location.search.includes("design"),
        external: false,
        isTeam: true,
      },
      ...teamsList,
    ],
    [location, teamsList, t]
  );


  const { onSave: onModalTagsSave, selectedTags } = useSelector(TagsSelector);

  const handleToggleMobileMenu = useCallback(
    (val: boolean) => {
      dispatch(MobileMenuStateAction.toggle(val));
      dispatch(setIsOpen(val));
    },
    [dispatch]
  );

  const handleModalTagSave = useCallback(() => {
    if (onModalTagsSave) onModalTagsSave(selectedTags);
    dispatch(setIsOpen(false));
    hideModal();
  }, [onModalTagsSave, hideModal, selectedTags, dispatch])

  const saveTagsMobileButtonVisible = useMemo(() => {
    if (is568bp && isGeo) return false;
    return isMobileSelectTags && !(isProHse || isPro) && is744
  }, [is568bp, isMobileSelectTags, isPro, is744])

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      // @ts-ignore
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [setQueryParams, dispatch, i18n]
  );

  const handleLangChange = () => {
    onLangSwitch?.();
    //todo indicate somehow that language is changed
  };

  const handleLogoClick = () => {
    if (isOnlines) {
      history.push("/");
    }
    //@ts-ignore
    isIllustration && !isTagsModalActive
      ? (window.location.href = process.env.REACT_APP_URL_HSEDESIGN_RU || "")
      : history.push(LinkTo.explore);
    //todo move everything to shared modals
    setVisibleModalMenuCategoriesMobile(false);
    handleToggleMobileMenu(false);
    hideModal();
    toggleMobileEditor && toggleMobileEditor(false);
  };

  const locationDep = location.pathname;

  useEffect(
    () => () => {
      setVisibleModalMenuCategoriesMobile(false);
      handleToggleMobileMenu(false);
      if (modal.name !== "paymentManager") {
        hideModal();
      }
    },
    [handleToggleMobileMenu, hideModal, locationDep]
  );

  useEffect(() => {
    setUserParam();
  }, [location, setUserParam]);

  useEffect(() => {
    if (isOnlines) {
      i18n.changeLanguage(lang);
    }
  }, [isOnlines, i18n, lang]);

  const theming = useMemo(
    () => ({
      zIndex: 99999,
      backgroundColor: !isGeo && !isGameDeziiign && !isCGRave
        ? theme.navigationBar.backgroundColor
        : theme.app.backgroundColor,
      borderBottomColor: theme.navigationBar.borderBottomColor,
      backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
      boxShadow: theme.navigationBar.boxShadow,
      mobile: true,
    }),
    [
      isGeo,
      theme.app.backgroundColor,
      theme.navigationBar.backgroundColor,
      theme.navigationBar.backgroundScrollingColor,
      theme.navigationBar.borderBottomColor,
      theme.navigationBar.boxShadow,
    ]
  );

  const shouldDisplaySearchBar = useMemo(
    () =>
      !isMobile &&
      !isEditPage &&
      (getShouldDisplaySearch()),
    [isMobile, isEditPage]
  );

  const shouldDisplayLangSwitcher = useMemo(() => {
    if (isGreenAward || isLPU) {
      return null;
    }

    if (
      (isProjectEdit || isBookEdit) &&
      !is744 &&
      (
        isBrnd ||
        isSuperPuper ||
        isOnlines ||
        !someModalIsOpen ||
        isMobileSelectTags
      )
    ) {
      return true;
    }

    if (
      !isSuperPuper &&
      !isLPU &&
      someModalIsOpen &&
      !isGreenAward &&
      !isOnlines &&
      !isMobileSelectTags
    ) {
      return true;
    }

    return true;
  }, [
    isProjectEdit,
    isBookEdit,
    is744,
    isOpen,
    isMobileSelectTags,
    isActiveModal,
    isTagsModalActive,
    isReportModalActive,
    isCompetitionEdit,
    isLMS,
    isMobile
  ])

  const onCreateClick = useCallback(() => {

    if (token) {
      if (isKiiidsArt) {
        createKidsCard()
        return
      }
      if (isCompetitions) {
        history.push(CreateLinkTo.competitionCreate());
      } else if (isBooks || isDesignBooks || isGalllleryBooks /*|| isVisualResearch*/) {
        history.push(CreateLinkTo.bookCreate());
      } else {
        history.push(CreateLinkTo.projectCreate());
      }
    } else {
      emit("login");
    }
  }, [token, isKiiidsArt, isCompetitions, isBooks, isDesignBooks, isGalllleryBooks, createKidsCard, history, emit]);

  const onPreviewExit = useCallback(() => {
    if (token && id) {
      if (isMainBookPreview) {
        return history.push(CreateLinkTo.bookEdit(mainBookId));
      }
      if (isBookChapterPreview) {
        return history.push(CreateLinkTo.bookEdit(id));
      }
      if (isBooks) {
        return history.push(CreateLinkTo.bookEdit(id));
      }
      if (isTeamPreview) {
        return history.push(CreateLinkTo.teamEdit(id));
      }
      if (isTeamLgPreview) {
        return history.push(CreateLinkTo.teamEdit(id) + "?tab=lg");
      }
      return history.push(CreateLinkTo.projectEdit(id));
    }
  }, [
    token,
    id,
    isBookChapterPreview,
    isMainBookPreview,
    mainBookId,
    history,
    isBooks,
    isTeamPreview,
    isTeamLgPreview,
  ]);

  const shouldDisplayLoginWidget = useMemo(() => {
    if (someModalIsOpen) {
      return (
        !isSuperPuper &&
        !isLPU &&
        !isGreenAward &&
        !isOnlines &&
        !isMobileSelectTags
      );
    }

    return !isEditPageOrPreview
  }, [someModalIsOpen, isEditPageOrPreview, isMobileSelectTags]);

  const shouldDisplayTeamAdminButtons = (
    isNeedTeamButtons &&
    is568bp &&
    !isMobileSelectTags &&
    !isOpen
  );

  const shouldDisplayIcons = (
    !isOpen &&
    !isTagsModalActive &&
    !isMobileEditorOpen &&
    (isProjectOnlyEdit || isProjectPreview) &&
    shouldDisplayEditorInterface
  )

  const MobileIcons = useMemo(() => {
    if (!shouldDisplayIcons) return null;

    return (
      <AbsoluteWrapper offsetRight={16} gx={16} centered={!is744} isTeamEdit>
        <MobileSaveBlock
          onClick={onMobileProjectSaveClick}
          visible={is744}
        />
        {(isProjectEdit ||
          isBookEdit ||
          isCompetitionEdit ||
          shouldVisibleTeamPreview) &&
          !!onPreviewClick && (
            <div id="preview-button" onClick={onPreviewClick}>
              <PreviewIconOpen />
            </div>
          )}
        {isPreview && !!onPreviewExit && (
          <div id="preview-button" onClick={onPreviewExit}>
            <IconWrapper>
              <PreviewIconClosed />
            </IconWrapper>
          </div>
        )}
      </AbsoluteWrapper>
    )
  }, [
    shouldDisplayIcons,
    onMobileProjectSaveClick,
    onPreviewClick, onPreviewExit,
    is744,
    isProjectEdit,
    isBookEdit,
    isCompetitionEdit,
    shouldVisibleTeamPreview,
    isPreview
  ])

  return (
    <ThemeProvider theme={setTheme}>
      <NavBarWrapper isKiiidsArt={isKiiidsArt}>
        <NavBar
          theming={theming}
          logo={mainLogo}
          onLogoClick={handleLogoClick}
          context={
            shouldDisplayContextOnNavbar ? t(`context_names.${contextName}`) : ""
          }
          sections={[
            [
              ...(!isOpen &&
                !isTagsModalActive &&
                !isCompetitionLongreadSendProjectActive &&
                !isMobileEditorOpen &&
                !isProjectOnlyEdit &&
                !isProjectPreview
                ? [
                  <AbsoluteWrapper centered={false} isTeamEdit>
                    {(isProjectEdit ||
                      isCompetitionEdit ||
                      isBookEdit ||
                      shouldVisibleTeamPreview) &&
                      !!onPreviewClick && (
                        <div id="preview-button" onClick={onPreviewClick}>
                          <PreviewIconOpen />
                        </div>
                      )}
                    {isPreview && !!onPreviewExit && (
                      <div id="preview-button" onClick={onPreviewExit}>
                        <IconWrapper>
                          <PreviewIconClosed />
                        </IconWrapper>
                      </div>
                    )}
                  </AbsoluteWrapper>,
                ]
                : []),
            ],
            [
              ...(isOnlines
                ? [
                  <>
                    {!isOpen && (
                      <NeutralLink to="/open-day">
                        <OpenDayButton>
                          {t("onlinesNav.btns.open_day")}
                        </OpenDayButton>
                      </NeutralLink>
                    )}
                    {(isOpen || isTagsModalActive) && isOnlines && (
                      <BLanguageSelectionComponentOnlines
                        onLangSelect={onOnlinesLangSwitch}
                        key="lang"
                      />
                    )}
                    {!isOpen && (
                      <ApplyBtn
                        lang={i18n.language}
                        href={ANCHOR_ONLINES_LINK + onlinesUserParam}
                        size={"small"}
                      >
                        {t("onlinesNav.btns.apply")}
                      </ApplyBtn>
                    )}
                  </>,
                ]
                : [
                  <RightSection>
                    {!is744 && MobileIcons}
                    {shouldDisplaySearchBar && !isOpen && (
                      <MainSearchButton />
                    )}
                    {!isEditPageOrPreview &&
                      !isActiveModal &&
                      !isOpen && (
                        <>
                          {shouldDisplayNotifications && (
                            <>
                              <NotificationsController />
                              {shouldDisplayChannelButton && <ChannelButton />}
                              {shouldDisplayFeedButton && <FeedButton />}
                            </>
                          )}
                          <TeamInfo />
                        </>
                      )}
                    {shouldDisplayGameButton && <GameButton />}
                    {shouldDisplayLangSwitcher && (
                      <LangSwitcherWrapper
                        isOpen={isOpen}
                        isKiiidsArt={isKiiidsArt}
                        offsetRight={isSuperPuper ? 6 : 16}
                        offsetLeft={16}
                      >
                        <BLangSwitcher
                          currentLanguage={i18n.language}
                          onLangSelect={handleLangChange}
                          key="lang"
                          mobile
                          activeBg={isKiiidsArt ? '#94209E' : ''}
                          itemStyle={isKiiidsArt ? 'border-radius: 8px;' : ''}
                        />
                      </LangSwitcherWrapper>
                    )}
                    {PhoneButton}
                    {shouldDisplayCreateButton && !is430bp && !modalName &&
                      (
                        <DropdownWrapper key="mobile-create-dropdown">
                          {shouldDisplayProDropdown ? (
                            <CreatePresentationButton />
                          ) : (
                            <CreateButton style={isGreenAward ? { marginLeft: '10px' } : {}} onClick={onCreateClick} isKiiids={isKiiidsArt} isMedia={isMedia}>
                              {createButtonTitle}
                            </CreateButton>
                          )}
                        </DropdownWrapper>
                      )
                    }
                    {shouldVisibleCourseList && <CourseInfoListController />}
                    {is744 && MobileIcons}
                    {is744 &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      (isProjectOnlyEdit || isProjectPreview || isBookEdit || isBookChapterPreview || isBooksGallllery) && (
                        <AgreeButtonWrapper
                          disabled={!canSaveLgText}
                          isPreview={!!isPreview}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          <AgreeOrClose type={mobileIconState} enabled={true} />
                        </AgreeButtonWrapper>
                      )}
                    {is568bp &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isBookChapterPreview &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      !isProjectOnlyEdit &&
                      !isProjectPreview && (
                        <ProjectSaveButton
                          disabled={!canSaveInDrafts || !previewButtonEnabled}
                          fixedSize
                          style={{ marginRight: "11px" }}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          {t("project_edit.save")}
                        </ProjectSaveButton>
                      )}
                    {shouldVisibleSaveBtn &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {isTeamEdit
                            ? primaryButtonText
                            : t("project_edit.save")}
                        </ProjectSaveButton>
                      )}

                    {/*КНОПКИ ДЛЯ РЕДАКТИРОВАНИЯ  ОРГАНИЗАЦИЙ В МОДЕРКЕ*/}
                    {shouldDisplayTeamAdminButtons && (
                      <>
                        <ExitButton isTeamEdit onClick={onSecondaryClick}>
                          {secondaryButtonText}
                        </ExitButton>
                        <ProjectSaveButton
                          style={{ marginLeft: 8 }}
                          fixedSize
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {primaryButtonText}
                        </ProjectSaveButton>
                      </>
                    )}
                    {saveTagsMobileButtonVisible && (
                      <SaveButton
                        onClick={handleModalTagSave}
                      >
                        {t("project_edit.save")}
                      </SaveButton>
                    )}
                    {!isCompetitionLongreadSendProjectActive && !is744 &&
                      (isEditPage || (isProfileEdit && !is744)) &&
                      !isMobileSelectTags &&
                      !isPreview &&
                      !isMobileEditorOpen &&
                      !isGeoTagModalActive &&
                      !isOpen &&
                      secondaryButtonVisible && (
                        <ExitButton
                          style={{ ...(isProfileEdit && { marginRight: 16 }) }}
                          fixedSize
                          onClick={() =>
                            (isEditPage || isProfileEdit) &&
                              onSecondaryClick
                              ? onSecondaryClick()
                              : history.push(CreateLinkTo.explore())
                          }
                        >
                          {isTeamEdit
                            ? secondaryButtonText
                            : t("nav.exit_other") ?? "Exit"}
                        </ExitButton>
                      )}

                    {shouldDisplayLoginWidget && <WidgetLogin />}
                  </RightSection>,
                ]),
            ],
          ]}
        />

        

        <ModalMenuContextMobileNew
          hseUrls={urlsList}
          visible={menuVisible}
          closeMenu={closePopup}
        />

        <MobileBottomBar
          primaryButtonData={{
            onClick: onPrimaryClick,
            enabled: primaryButtonEnabled,
            text: primaryButtonText,
          }}
          onSave={handleModalTagSave}
          isMobileEditorOpen={isMobileEditorOpen}
        />
      </NavBarWrapper>
    </ThemeProvider>
  );
};

export default DeziignNavBarMobile;
import {
  FC,
  useMemo,
  useCallback,
  useState,
  useEffect,
  ReactElement,
} from "react";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  LayoutConst,
  modalControllerActions,
  modalControllerSelector,
  ModalControllerSlice,
  SHARED_MODALS,
  useModal,
} from "core";
import {
  AppTester,
  getContextFromAppName,
} from "supporting";
import { ApplicationShared } from "core";
import { ApplicationTheme } from "shared/themes";
import { useAuth } from "core/hooks/auth/useAuth";
import { NavBar } from "shared/components/__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import WidgetLogin from "./WidgetLogin";
import MobileBottomBar from "./MobileBottomBar";
import { useSelector, useDispatch } from "react-redux";
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "../components/buttons";
import {
  FlexBox,
  FInter,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled,
  Colors,
  useToasts
} from "@brg/ui";
import { AbsoluteWrapper } from "../components/navbar-elements/navbar-create";
import PreviewIconOpen from "../assets/32/PreviewIconOpen";
import PreviewIconClosed from "../assets/32/PreviewIconClosed";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "shared/components/link/styles";
import {
  ANCHOR_ONLINES_LINK,
  ApplyBtn,
} from "shared/components/Footer/OnlinesFooter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import useQueryState from "shared/hooks/useQueryState";
import { OpenDayButton } from "./DeziiignNavbar";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { TagsSelector } from "../reducers/Tags";
import { DropdownWrapper } from "./HSEDeziiignNavbar";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { ORGANIZATION_LIST } from "shared/hooks/useGetCurrentTeam";
import { GeoTagModalSelector } from "shared/reducers/geoTagsModal";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo, { PhoneText } from "../components/TeamInfo/TeamInfo";
import { CourseInfoListController } from "shared/components/CourseInfoListController/CourseInfoListController";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import { AgreeOrClose, IconStates } from "./components/AgreeOrClose";
import { MobileSaveBlock } from "./components/MobileSaveBlock";
import FeedButton from "../components/NotificationsController/FeedButton";
import { setIsOpen } from "shared/reducers/OpenModal";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { Input } from "@brg/input";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { HsePolicies } from "shared/constants/HsePolicies";
import useNavbarSettings from "shared/hooks/useNavbarSettings";
import CreatePresentationButton from "./components/CreatePresentationButton";

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 1;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
  ${FlexBox} {
    @media (max-width: 568px) {
      margin-right: 6px; /* важно, изменения для всего сайта */
    }
  }
`;

export const NavbarOuter = styled(FlexBox) <{
  shifted?: boolean;
  isAgeytomesh?: boolean;
  logoLength?: number;
}>`
  max-width: 300px;
  position: relative;
  left: ${(p) => (p?.shifted ? `-${p?.logoLength}px` : 0)};
  transition: all 500ms;
`;

export const LogoName = styled(FlexBox) <{ isGeo?: boolean; isDafes?: boolean }>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${({ isDafes }) => isDafes ? '17px' : '24px'};
  line-height: ${({ isDafes }) => isDafes ? '22px' : '40px'};
  color: ${(p) =>
    p?.isDafes ? "#151514" : p.theme.navigationBar.logoName};
  position: relative;
  top: -1px;

  ${(p) =>
    p?.isGeo
      ? css`
          font-size: 17px;
          line-height: 22px;
          top: 1px;
        `
      : null};
`;

const RightSection = styled.div<{ isDafes?: boolean }>`
  display: flex;
  align-items: center;
`;

const CreateButton = styled.div<{ hide?: boolean, isMedia?: boolean, isKiiids?: boolean }>`
  display: ${({ hide }) => (hide ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  background: ${({ theme, isKiiids }) => isKiiids ? '#94209E' : theme.navigationBar.btns.create.bg};
  border-radius: ${({ isMedia, isKiiids }) => isMedia || isKiiids ? '8px' : '3px'};
  font-family: Inter, sans-serif;
  font-style: normal;
  height: 36px;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.navigationBar.btns.create.color};
  margin-right: 16px;
  // min-width: 132px;
  min-width: auto;
  padding: 8px 24px;
  max-width: min-content;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    height: ${({ isKiiids }) => isKiiids ? 40 : 32}px;
  }

  // @media (max-width: ${LayoutConst.screen.sm}px) {
  //   height: 30px;
  //   margin-right: 6px;
  //   min-width: 84px;
  //   padding: 6px 15px;
  //   max-width: 84px;
  // }
`;

const ExitButton = styled(RectangularButtonHollow) <{ isTeamEdit?: boolean }>`
  margin-right: 14px;
  // width: 87px !important;
  // min-width: 87px !important;
  width: auto !important;
  min-width: auto !important;
  height: 36px !important;
  margin-left: 16px;
  margin-right: 0;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: ${({ isTeamEdit }) => (isTeamEdit ? "28px" : "26px")} !important;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

`;

const SaveButton = styled(NavbarButtonFilled)`
  width: auto;
  min-width: auto;
  max-width: none;
  line-height: 16px;
  height: 36px !important;
  padding: 4px 24px;
  min-height: 24px;
  margin-right: 6px;
  font-weight: 600 !important;
  letter-spacing: normal;
`;

const AgreeButtonWrapper = styled.button<{ disabled?: boolean, isPreview?: boolean }>`
    margin-bottom: 6px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;
    ${({ isPreview }) =>
    isPreview
      ? css`
            margin-right: 16px;
          `
      : null};

  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ disabled }) =>
    disabled ? Colors.galBlack47 : Colors.galBlack100};
      }
    }
  }
  &:focus {
    outline: none;
  }
`;

const ProjectSaveButton = styled(NavbarButtonFilled)`
  // width: 132px;
  width: auto;
  min-width: auto;
  height: 36px !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: 568px) {
    // width: 102px;
    // min-width: 102px;
    width: auto;
    min-width: auto;
    height: 28px !important;
    min-height: 28px;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  &:disabled {
    background-color: ${({ theme }) =>
    theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) =>
    theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const IconWrapper = styled(FlexBox)`
  & svg {
    stroke-width: 0.2px;
  }
`


const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt &&
    css`
      & > div > div > div {
        background-color: rgb(231, 231, 231); 
      }
      div#navbar {
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px), (max-width: ${LayoutConst.screen.sm}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const LangSwitcherWrapper = styled(FlexBox) <any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin: 0 8px 0 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0 8px 0 0;
  }
`

type PropsT = {
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  primaryButtonEnabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPreviewClick?: () => void;
  dropdown?: ReactElement;
  currentTheme?: any;
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  toggleMobileEditor?: (val: boolean) => void;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  canSaveLgText?: boolean;
};

const DeziignNavBarMobile: FC<PropsT> = ({
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonEnabled,
  previewButtonEnabled,
  primaryButtonVisible = true,
  secondaryButtonVisible = true,
  primaryButtonText,
  secondaryButtonText,
  onPreviewClick,
  mobileEditorOpen,
  toggleMobileEditor,
  canSaveInDrafts,
  previewButtonVisible,
  closeIconVisible = false,
  canSaveLgText,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const isBooksGallllery = AppTester.isBooksGallllery()
  const { emit, token } = useAuth();
  const location = useLocation();
  const toasts = useToasts();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const modal = useSelector(modalControllerSelector);
  const modalToggle = useModal();
  const modalIsOpen = useMemo(() => !!modal.name, [modal]);
  const { hide: hideModal } = useModal();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/books/preview/:id",
    "/book-preview/:id",
    "/team-preview/:id",
    "/team-longread-preview/:id",
  ]);
  const isProjectPreview = useRouteMatch<{ id: string }>(["/preview/:id"]);
  const isProjectOnlyEdit = useRouteMatch<{ id: string }>(["/edit/:id"]);
  const isTeamPreview = useRouteMatch<{ id: string }>("/team-preview/:id");
  const isTeamLgPreview = useRouteMatch<{ id: string }>(
    "/team-longread-preview/:id"
  );
  const isBookChapterPreview = !!useRouteMatch([
    "/books/preview/:id",
    "/book-preview",
  ]);
  const isProjectEdit = useRouteMatch<{ id: string }>([
    "/edit/:id",
    "/books/edit/:id",
  ]);
  const isBookEdit = useRouteMatch<{ id: string }>([
    "/books/book-edit/:id",
    "/book-edit/:id",
  ]);
  const isBooksEdit = useRouteMatch<{ id: string }>("/books/edit/:id");
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const isProfileEdit = useRouteMatch<{ id: string }>(LinkTo.designerEdit);
  const isProfilePage = useRouteMatch<{ id: string }>(LinkTo.designer);
  const isTeamEdit = !!useRouteMatch(LinkTo.teamEdit);

  const {
    shouldDisplayEditorInterface,
    shouldDisplayNotifications,
    shouldDisplayGameButton,
    shouldDisplayCreateButton,
    shouldDisplayProDropdown,
    shouldDisplayChannelButton,
    shouldDisplayFeedButton,
    createButtonTitle,
    onLangSwitch,
  } = useNavbarSettings();

  const isEditPage = (
    isProjectEdit ||
    isTeamEdit ||
    isBookEdit ||
    isCompetitionEdit
  ) && shouldDisplayEditorInterface;

  // const isEditPage = false;

  const isEditPageOrPreview = (isEditPage || isPreview) && shouldDisplayEditorInterface;

  const isBrnd = AppTester.isBrnd();
  const isMedia = AppTester.isMediiia();
  const isCGRave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGreenAward = AppTester.isGreenAward();
  const isLPU = AppTester.isLPUDesign();
  const id = isPreview && isPreview?.params?.id;
  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is430bp = useBreakpoint(470);
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const [{ lang, mainBookId }, setQueryParams] = useQueryState();
  const { initialTab, context: contextName } = useContextsTabs();

  const mainLogo = useGetLogo({})

  const [setUserParam] = useOnlinesParam();
  const onlinesUserParam = sessionStorage.getItem("userParam");

  const [, setVisibleModalMenuCategoriesMobile] = useState<boolean>(false);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);

  const closePopup = useCallback(() => {
    dispatch(setIsOpen(false));
  }, [dispatch]);

  const onMobileProjectSaveClick = () => {
    if (!primaryButtonEnabled) {
      toasts.error(t('nav.create_button.fields_required'))
      return
    }

    const onProjectSaveClick = (val: boolean) => {
      if (!!val) {
        onPrimaryClick && onPrimaryClick();
        modalToggle.hide();
        return;
      }

      modalToggle.hide();
    }

    modalToggle.show('project-publish', {
      onClick: onProjectSaveClick
    })
  }

  const isMainBookPreview = useMemo(() => (mainBookId && isBookChapterPreview), [isBookChapterPreview, mainBookId])

  const shouldVisibleTeamPreview = useMemo(
    () => isTeamEdit && !!previewButtonVisible,
    [isTeamEdit, previewButtonVisible]
  );

  const mobileIconState = useMemo(
    () => mobileEditorOpen ? IconStates.button : IconStates.close, [mobileEditorOpen, closeIconVisible])

  const isGeo = AppTester.isGeograffee();
  const isHSEDesign = AppTester.isHSEDesign();
  const isOnlines = AppTester.isOnlines();
  const isSuperPuper = AppTester.isSuperPuper();
  const isContinuumSite = AppTester.isContinuumSite();
  const isKiiidsArt = AppTester.isKiiidsArt()

  const isDafes = AppTester.isGeoDafes();
  const isBooks = !!useRouteMatch([
    LinkTo.hseBooks,
    "/hsebooks",
  ]);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isHseColors = AppTester.isHseColors();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isReportModalActive =
    useSelector(modalControllerSelector).name === "report";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isNotSavedDataModal =
    useSelector(modalControllerSelector).name === "not-saved-data";
  const isCompetitionLongreadSendProjectActive = useSelector(modalControllerSelector).name === "send-project-longread"

  const menuVisible = useMemo(
    () => (isOpen && !isNotSavedDataModal)
    , [isOpen, isNotSavedDataModal])

  const isGeoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;

  const setTheme = isSuperPuper || isCGRave || isContinuumSite || isAdcrDafesNet
    ? ApplicationTheme.black
    : isDafes
      ? ApplicationTheme.white
      : isGeo
        ? ApplicationTheme.grey
        : isGameDeziiign
          ? ApplicationTheme.additionalGreyTheme
          : isGalllleryBooks
            ? ApplicationTheme.additionalWhite_1
            : ApplicationTheme.white;

  const profile = useProfile();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);

  const isCreateLocationPage = !!useRouteMatch(LinkTo.createLocation);

  const isProHse = AppTester.isProHSE();
  const isPro = AppTester.isProDeziiign()

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  const { teamName } = useParams<{ teamName: string }>();
  const team = useExternalOrganization(teamName);

  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;

  const isMobileSelectTags = useMemo(
    () =>
      modalName === "tags" &&
      (isProjectOnlyEdit ||
        isBookEdit ||
        isCreateLocationPage ||
        isTeamEdit ||
        isBooksEdit ||
        isCompetitionEdit) &&
      isMobile,
    [
      isBookEdit,
      isBooksEdit,
      isCompetitionEdit,
      isTeamEdit,
      isCreateLocationPage,
      modalName,
      isMobile,
    ]
  );

  const shouldDisplayContextOnNavbar = useMemo(
    () => isHSEDesign && !isProfilePage,
    [isHSEDesign, isProfilePage]
  );

  const shouldVisibleSaveBtn = useMemo(() => {
    if (is744) {
      return false;
    }

    return (isEditPage && isTablet && primaryButtonVisible) || isProfileEdit;
  }, [isEditPage, isTablet, isProfileEdit, is744, primaryButtonVisible]);

  const shouldVisibleCourseList = isMobile && isLMS && !isTagsModalActive;

  const PhoneButton = useMemo(() => (isHseColors && !isOpen && (
    <FlexBox offsetRight={isMobile ? 16 : 0}>
      <RectangularButtonFilled smallPadding onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
        <PhoneText style={{ color: Colors.geoWhite100 }}>
          +7 999 999 99-99
        </PhoneText>
      </RectangularButtonFilled>
    </FlexBox>
  )), [isHseColors, isMobile, toasts, t, isOpen])

  // очередной костыль, я не понимаю почему у меня выдает ошибки при каждом изменний условий
  const isNeedTeamButtons = useMemo(
    () => isTeamEdit && !isCompetitionLongreadSendProjectActive && (secondaryButtonVisible || primaryButtonVisible)
    , [isCompetitionLongreadSendProjectActive, isTeamEdit, primaryButtonVisible])

  const cardUrl = Endpoints.cardsMnePw;

  const createKidsCard = useCallback(async () => {
    if (!profile) {
      return
    }
    const catalogs = await API.request()
      .endpoint(cardUrl)
      .url('api/Collection/GetCatalogs')
      .get()
      .addQuery('service', 'kids')
      .addQuery('userId', profile?.accountId)
      .addQuery('isUserCatalog', 'true')
      .send()
      .then((r: any) => r.json())

    const collectionId = catalogs?.[0]?.cardCollectionId


    const cardData: any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
    }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))

    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
  }, [cardUrl, profile])


  const isShadowModal = useMemo(
    () => SHARED_MODALS[modal?.name]?.shadowClosableBackground,
    [modal?.name]
  );
  const isActiveModal = useMemo(
    () => Boolean(modalName) && !isShadowModal,
    [modalName, isShadowModal]
  );

  const isMobileEditorOpen = useMemo(
    () => (mobileEditorOpen && isMobile && !!toggleMobileEditor) || false,
    [mobileEditorOpen, isMobile, toggleMobileEditor]
  );

  const someModalIsOpen = isOpen || isTagsModalActive || isActiveModal || isMobileEditorOpen


  const teamsList = useMemo(() => {
    let res = [];
    for (let key in ORGANIZATION_LIST) {
      //@ts-ignore
      if (!["ageytomesh", "books"].includes(key) && !ORGANIZATION_LIST[key].disabled
      ) {
        res.push({
          //@ts-ignore
          title: ORGANIZATION_LIST[key]?.[language === "ru" ? "titleRu" : "title"],
          name: key,
          value: `/teams/${key}`,
          ctx: "",
          active: location.pathname?.includes(key),
          external: false,
          isTeam: true,
        });
      }
    }
    return res;
  }, [location, language]);

  const urlsList = useMemo(
    () => [
      {
        title: t("nav.laboratory").toLowerCase(),
        name: "laboratory",
        value: "/teams/hselab",
        ctx: "",
        active:
          location.pathname.includes("/hselab") &&
          !location.search.includes("design"),
        external: false,
        isTeam: true,
      },
      ...teamsList,
    ],
    [location, teamsList, t]
  );


  const { onSave: onModalTagsSave, selectedTags } = useSelector(TagsSelector);

  const handleToggleMobileMenu = useCallback(
    (val: boolean) => {
      dispatch(MobileMenuStateAction.toggle(val));
      dispatch(setIsOpen(val));
    },
    [dispatch]
  );

  const handleModalTagSave = useCallback(() => {
    if (onModalTagsSave) onModalTagsSave(selectedTags);
    dispatch(setIsOpen(false));
    hideModal();
  }, [onModalTagsSave, hideModal, selectedTags, dispatch])

  const saveTagsMobileButtonVisible = useMemo(() => {
    if (is568bp && isGeo) return false;
    return isMobileSelectTags && !(isProHse || isPro) && is744
  }, [is568bp, isMobileSelectTags, isPro, is744])

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      // @ts-ignore
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [setQueryParams, dispatch, i18n]
  );

  const handleLangChange = () => {
    onLangSwitch?.();
    //todo indicate somehow that language is changed
  };

  const handleLogoClick = () => {
    if (isOnlines) {
      history.push("/");
    }
    //@ts-ignore
    isIllustration && !isTagsModalActive
      ? (window.location.href = process.env.REACT_APP_URL_HSEDESIGN_RU || "")
      : history.push(LinkTo.explore);
    //todo move everything to shared modals
    setVisibleModalMenuCategoriesMobile(false);
    handleToggleMobileMenu(false);
    hideModal();
    toggleMobileEditor && toggleMobileEditor(false);
  };

  const locationDep = location.pathname;

  useEffect(
    () => () => {
      setVisibleModalMenuCategoriesMobile(false);
      handleToggleMobileMenu(false);
      if (modal.name !== "paymentManager") {
        hideModal();
      }
    },
    [handleToggleMobileMenu, hideModal, locationDep]
  );

  useEffect(() => {
    setUserParam();
  }, [location, setUserParam]);

  useEffect(() => {
    if (isOnlines) {
      i18n.changeLanguage(lang);
    }
  }, [isOnlines, i18n, lang]);

  const theming = useMemo(
    () => ({
      zIndex: 99999,
      backgroundColor: !isGeo && !isGameDeziiign && !isCGRave
        ? theme.navigationBar.backgroundColor
        : theme.app.backgroundColor,
      borderBottomColor: theme.navigationBar.borderBottomColor,
      backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
      boxShadow: theme.navigationBar.boxShadow,
      mobile: true,
    }),
    [
      isGeo,
      theme.app.backgroundColor,
      theme.navigationBar.backgroundColor,
      theme.navigationBar.backgroundScrollingColor,
      theme.navigationBar.borderBottomColor,
      theme.navigationBar.boxShadow,
    ]
  );

  const shouldDisplaySearchBar = useMemo(
    () =>
      !isMobile &&
      !isEditPage &&
      (getShouldDisplaySearch()),
    [isMobile, isEditPage]
  );

  const shouldDisplayLangSwitcher = useMemo(() => {
    if (isGreenAward || isLPU) {
      return null;
    }

    if (
      (isProjectEdit || isBookEdit) &&
      !is744 &&
      (
        isBrnd ||
        isSuperPuper ||
        isOnlines ||
        !someModalIsOpen ||
        isMobileSelectTags
      )
    ) {
      return true;
    }

    if (
      !isSuperPuper &&
      !isLPU &&
      someModalIsOpen &&
      !isGreenAward &&
      !isOnlines &&
      !isMobileSelectTags
    ) {
      return true;
    }

    return true;
  }, [
    isProjectEdit,
    isBookEdit,
    is744,
    isOpen,
    isMobileSelectTags,
    isActiveModal,
    isTagsModalActive,
    isReportModalActive,
    isCompetitionEdit,
    isLMS,
    isMobile
  ])

  const onCreateClick = useCallback(() => {

    if (token) {
      if (isKiiidsArt) {
        createKidsCard()
        return
      }
      if (isCompetitions) {
        history.push(CreateLinkTo.competitionCreate());
      } else if (isBooks || isDesignBooks || isGalllleryBooks /*|| isVisualResearch*/) {
        history.push(CreateLinkTo.bookCreate());
      } else {
        history.push(CreateLinkTo.projectCreate());
      }
    } else {
      emit("login");
    }
  }, [token, isKiiidsArt, isCompetitions, isBooks, isDesignBooks, isGalllleryBooks, createKidsCard, history, emit]);

  const onPreviewExit = useCallback(() => {
    if (token && id) {
      if (isMainBookPreview) {
        return history.push(CreateLinkTo.bookEdit(mainBookId));
      }
      if (isBookChapterPreview) {
        return history.push(CreateLinkTo.bookEdit(id));
      }
      if (isBooks) {
        return history.push(CreateLinkTo.bookEdit(id));
      }
      if (isTeamPreview) {
        return history.push(CreateLinkTo.teamEdit(id));
      }
      if (isTeamLgPreview) {
        return history.push(CreateLinkTo.teamEdit(id) + "?tab=lg");
      }
      return history.push(CreateLinkTo.projectEdit(id));
    }
  }, [
    token,
    id,
    isBookChapterPreview,
    isMainBookPreview,
    mainBookId,
    history,
    isBooks,
    isTeamPreview,
    isTeamLgPreview,
  ]);

  const shouldDisplayLoginWidget = useMemo(() => {
    if (someModalIsOpen) {
      return (
        !isSuperPuper &&
        !isLPU &&
        !isGreenAward &&
        !isOnlines &&
        !isMobileSelectTags
      );
    }

    return !isEditPageOrPreview
  }, [someModalIsOpen, isEditPageOrPreview, isMobileSelectTags]);

  const shouldDisplayTeamAdminButtons = (
    isNeedTeamButtons &&
    is568bp &&
    !isMobileSelectTags &&
    !isOpen
  );

  const shouldDisplayIcons = (
    !isOpen &&
    !isTagsModalActive &&
    !isMobileEditorOpen &&
    (isProjectOnlyEdit || isProjectPreview) &&
    shouldDisplayEditorInterface
  )

  const MobileIcons = useMemo(() => {
    if (!shouldDisplayIcons) return null;

    return (
      <AbsoluteWrapper offsetRight={16} gx={16} centered={!is744} isTeamEdit>
        <MobileSaveBlock
          onClick={onMobileProjectSaveClick}
          visible={is744}
        />
        {(isProjectEdit ||
          isBookEdit ||
          isCompetitionEdit ||
          shouldVisibleTeamPreview) &&
          !!onPreviewClick && (
            <div id="preview-button" onClick={onPreviewClick}>
              <PreviewIconOpen />
            </div>
          )}
        {isPreview && !!onPreviewExit && (
          <div id="preview-button" onClick={onPreviewExit}>
            <IconWrapper>
              <PreviewIconClosed />
            </IconWrapper>
          </div>
        )}
      </AbsoluteWrapper>
    )
  }, [
    shouldDisplayIcons,
    onMobileProjectSaveClick,
    onPreviewClick, onPreviewExit,
    is744,
    isProjectEdit,
    isBookEdit,
    isCompetitionEdit,
    shouldVisibleTeamPreview,
    isPreview
  ])

  return (
    <ThemeProvider theme={setTheme}>
      <NavBarWrapper isKiiidsArt={isKiiidsArt}>
        <NavBar
          theming={theming}
          logo={mainLogo}
          onLogoClick={handleLogoClick}
          context={
            shouldDisplayContextOnNavbar ? t(`context_names.${contextName}`) : ""
          }
          sections={[
            [
              ...(!isOpen &&
                !isTagsModalActive &&
                !isCompetitionLongreadSendProjectActive &&
                !isMobileEditorOpen &&
                !isProjectOnlyEdit &&
                !isProjectPreview
                ? [
                  <AbsoluteWrapper centered={false} isTeamEdit>
                    {(isProjectEdit ||
                      isCompetitionEdit ||
                      isBookEdit ||
                      shouldVisibleTeamPreview) &&
                      !!onPreviewClick && (
                        <div id="preview-button" onClick={onPreviewClick}>
                          <PreviewIconOpen />
                        </div>
                      )}
                    {isPreview && !!onPreviewExit && (
                      <div id="preview-button" onClick={onPreviewExit}>
                        <IconWrapper>
                          <PreviewIconClosed />
                        </IconWrapper>
                      </div>
                    )}
                  </AbsoluteWrapper>,
                ]
                : []),
            ],
            [
              ...(isOnlines
                ? [
                  <>
                    {!isOpen && (
                      <NeutralLink to="/open-day">
                        <OpenDayButton>
                          {t("onlinesNav.btns.open_day")}
                        </OpenDayButton>
                      </NeutralLink>
                    )}
                    {(isOpen || isTagsModalActive) && isOnlines && (
                      <BLanguageSelectionComponentOnlines
                        onLangSelect={onOnlinesLangSwitch}
                        key="lang"
                      />
                    )}
                    {!isOpen && (
                      <ApplyBtn
                        lang={i18n.language}
                        href={ANCHOR_ONLINES_LINK + onlinesUserParam}
                        size={"small"}
                      >
                        {t("onlinesNav.btns.apply")}
                      </ApplyBtn>
                    )}
                  </>,
                ]
                : [
                  <RightSection>
                    {!is744 && MobileIcons}
                    {shouldDisplaySearchBar && !isOpen && (
                      <MainSearchButton />
                    )}
                    {!isEditPageOrPreview &&
                      !isActiveModal &&
                      !isOpen && (
                        <>
                          {shouldDisplayNotifications && (
                            <>
                              <NotificationsController />
                              {shouldDisplayChannelButton && <ChannelButton />}
                              {shouldDisplayFeedButton && <FeedButton />}
                            </>
                          )}
                          <TeamInfo />
                        </>
                      )}
                    {shouldDisplayGameButton && <GameButton />}
                    {shouldDisplayLangSwitcher && (
                      <LangSwitcherWrapper
                        isOpen={isOpen}
                        isKiiidsArt={isKiiidsArt}
                        offsetRight={isSuperPuper ? 6 : 16}
                        offsetLeft={16}
                      >
                        <BLangSwitcher
                          currentLanguage={i18n.language}
                          onLangSelect={handleLangChange}
                          key="lang"
                          mobile
                          activeBg={isKiiidsArt ? '#94209E' : ''}
                          itemStyle={isKiiidsArt ? 'border-radius: 8px;' : ''}
                        />
                      </LangSwitcherWrapper>
                    )}
                    {PhoneButton}
                    {shouldDisplayCreateButton && !is430bp && !modalName &&
                      (
                        <DropdownWrapper key="mobile-create-dropdown">
                          {shouldDisplayProDropdown ? (
                            <CreatePresentationButton />
                          ) : (
                            <CreateButton style={isGreenAward ? { marginLeft: '10px' } : {}} onClick={onCreateClick} isKiiids={isKiiidsArt} isMedia={isMedia}>
                              {createButtonTitle}
                            </CreateButton>
                          )}
                        </DropdownWrapper>
                      )
                    }
                    {shouldVisibleCourseList && <CourseInfoListController />}
                    {is744 && MobileIcons}
                    {is744 &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      (isProjectOnlyEdit || isProjectPreview || isBookEdit || isBookChapterPreview || isBooksGallllery) && (
                        <AgreeButtonWrapper
                          disabled={!canSaveLgText}
                          isPreview={!!isPreview}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          <AgreeOrClose type={mobileIconState} enabled={true} />
                        </AgreeButtonWrapper>
                      )}
                    {is568bp &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isBookChapterPreview &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      !isProjectOnlyEdit &&
                      !isProjectPreview && (
                        <ProjectSaveButton
                          disabled={!canSaveInDrafts || !previewButtonEnabled}
                          fixedSize
                          style={{ marginRight: "11px" }}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          {t("project_edit.save")}
                        </ProjectSaveButton>
                      )}
                    {shouldVisibleSaveBtn &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {isTeamEdit
                            ? primaryButtonText
                            : t("project_edit.save")}
                        </ProjectSaveButton>
                      )}

                    {/*КНОПКИ ДЛЯ РЕДАКТИРОВАНИЯ  ОРГАНИЗАЦИЙ В МОДЕРКЕ*/}
                    {shouldDisplayTeamAdminButtons && (
                      <>
                        <ExitButton isTeamEdit onClick={onSecondaryClick}>
                          {secondaryButtonText}
                        </ExitButton>
                        <ProjectSaveButton
                          style={{ marginLeft: 8 }}
                          fixedSize
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {primaryButtonText}
                        </ProjectSaveButton>
                      </>
                    )}
                    {saveTagsMobileButtonVisible && (
                      <SaveButton
                        onClick={handleModalTagSave}
                      >
                        {t("project_edit.save")}
                      </SaveButton>
                    )}
                    {!isCompetitionLongreadSendProjectActive && !is744 &&
                      (isEditPage || (isProfileEdit && !is744)) &&
                      !isMobileSelectTags &&
                      !isPreview &&
                      !isMobileEditorOpen &&
                      !isGeoTagModalActive &&
                      !isOpen &&
                      secondaryButtonVisible && (
                        <ExitButton
                          style={{ ...(isProfileEdit && { marginRight: 16 }) }}
                          fixedSize
                          onClick={() =>
                            (isEditPage || isProfileEdit) &&
                              onSecondaryClick
                              ? onSecondaryClick()
                              : history.push(CreateLinkTo.explore())
                          }
                        >
                          {isTeamEdit
                            ? secondaryButtonText
                            : t("nav.exit_other") ?? "Exit"}
                        </ExitButton>
                      )}

                    {shouldDisplayLoginWidget && <WidgetLogin />}
                  </RightSection>,
                ]),
            ],
          ]}
        />

        

        <ModalMenuContextMobileNew
          hseUrls={urlsList}
          visible={menuVisible}
          closeMenu={closePopup}
        />

        <MobileBottomBar
          primaryButtonData={{
            onClick: onPrimaryClick,
            enabled: primaryButtonEnabled,
            text: primaryButtonText,
          }}
          onSave={handleModalTagSave}
          isMobileEditorOpen={isMobileEditorOpen}
        />
      </NavBarWrapper>
    </ThemeProvider>
  );
};

export default DeziignNavBarMobile;
